module.exports = "<article *ngIf=\"page\" class=\"page\">\n  <h3 *ngIf=\"show_title\" class=\"padding-top\">{{ page.title }}</h3>\n\n  <div [innerHTML]=\"page.text | noSanitize\" routeDirective class=\"padding-top-2x\"></div>\n</article>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Templates/page.html
// module id = ./src/app/Templates/page.html
// module chunks = main